<script>
import Page from '@/components/elements/Page';
export default {
    name: 'InternationalQRCode',
    components: {
        Page

    },
    created() {
        document.title = 'Gegevens in de vaccinatie QR-code';
    }
}
</script>

<template>
    <Page class="home" :displayBackButton=false>
        <div class="section">
            <div class="section-block" style="width:450px">
                <h2>Gegevens in de vaccinatie QR-code</h2>
                <p>
                    <ul style="margin-left: 40px;">
                    <li>(a) achternaam, voornaam(en) en geboortedatum;</li>
                    <li>(c) ziekteverwekker: COVID-19</li>
                    <li>(d) vaccin type, vaccin en vaccin producent</li>
                    <li>(g) aantal doses in een serie/ total aantal doses</li>
                    <li>(h) vaccinatie datum</li>
                    <li>(i) Lidstaat waarin is gevaccineerd</li>
                    <li>(j) Uitgever certificaat en een certificaat code</li>
                    </ul>
                </p>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.home {

    .home__section {
        margin-bottom: $length-l;
    }

    .UserConsent {
        margin: $grid-x6 0 $length-s 0;
    }

    .ErrorLabel {
        margin-bottom: $length-s;
    }
}
</style>
